import { defineAsyncComponent, markRaw } from "vue"
import SkeletonLoader from '@app/components/skeletons/SkeletonLoader.vue'

/**
 * Generates a dynamically imported vue component
 * 
 * @param {Function} component Function which returns an import
 * @returns {Raw}
 */
const rawDynamicImport = (component) => markRaw(
    defineAsyncComponent({
        loader           : component,
        loadingComponent : SkeletonLoader
    })
)

export {
    rawDynamicImport
}
